'use client';
import { useCallback, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { LandLinkMark } from "./landlink/shared";
import { ActZero } from "./landlink/ActZero";
import { ActOne } from "./landlink/ActOne";
import { ActTwo } from "./landlink/ActTwo";
import { ActThree } from "./landlink/ActThree";
import { ActFour } from "./landlink/ActFour";
import Footer from "../components/layout/Footer";

const ACT_COUNT = 5;

export default function LandlinkPage() {
  const [currentAct, setCurrentAct] = useState<0 | 1 | 2 | 3 | 4>(0);

  const actOne = useCallback(() => setCurrentAct(1), []);
  const actTwo = useCallback(() => setCurrentAct(2), []);
  const actThree = useCallback(() => setCurrentAct(3), []);
  const actFour = useCallback(() => setCurrentAct(4), []);

  return (
    <div className="landlink-page deck">
      <header className="deck-header">
        <LandLinkMark compact onClick={() => setCurrentAct(0)} />
        <div className="act-nav">
          <small>ACT 0{currentAct + 1}</small>
          <div>
            {Array.from({ length: ACT_COUNT }, (_, index) => (
              <i key={index} className={index <= currentAct ? "on" : ""}>
                <motion.span
                  animate={{
                    width: index <= currentAct ? "100%" : 0,
                    opacity: index === currentAct ? 1 : 0.35,
                  }}
                />
              </i>
            ))}
          </div>
        </div>
      </header>

      <main className="deck-stage">
        <AnimatePresence mode="wait" initial={false}>
          {currentAct === 0 && <ActZero key="zero" onComplete={actOne} />}
          {currentAct === 1 && <ActOne key="one" onComplete={actTwo} />}
          {currentAct === 2 && <ActTwo key="two" onComplete={actThree} />}
          {currentAct === 3 && <ActThree key="three" onComplete={actFour} />}
          {currentAct === 4 && <ActFour key="four" />}
        </AnimatePresence>
      </main>

      <Footer />
    </div>
  );
}
